import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as FeatherIcons from 'react-feather';
import { getNavItems } from '../../constants/navConfig';
import { getCurrentUserType } from '../../util/auth';
import './Sidebar.scss';

const Icon = ({ name, size = 16 }) => {
  const Comp = FeatherIcons[name] || FeatherIcons.Circle;
  return <Comp size={size} />;
};

const SidebarItem = ({ item, onClose }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const currentView = searchParams.get('view');

  const isItemActive = (item) => {
    if (item.type === 'group') return false;
    const pathMatch = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
    if (item.view) return pathMatch && currentView === item.view;
    return pathMatch;
  };

  const isGroupActive = (item) => item.children?.some(child => isItemActive(child));

  const [isOpen, setIsOpen] = useState(() => isGroupActive(item));

  useEffect(() => {
    if (isGroupActive(item)) setIsOpen(true);
  }, [location.pathname, currentView]); // eslint-disable-line react-hooks/exhaustive-deps

  if (item.type === 'group') {
    return (
      <div className={`sidebar-group ${isGroupActive(item) ? 'active' : ''}`}>
        <button className="sidebar-group-toggle" onClick={() => setIsOpen(o => !o)}>
          <span className="sidebar-icon"><Icon name={item.icon} /></span>
          <span className="sidebar-label">{item.label}</span>
          <span className={`sidebar-chevron ${isOpen ? 'open' : ''}`}>
            <Icon name="ChevronRight" size={14} />
          </span>
        </button>
        {isOpen && (
          <div className="sidebar-children">
            {item.children.map(child => (
              <SidebarItem key={child.id} item={child} onClose={onClose} />
            ))}
          </div>
        )}
      </div>
    );
  }

  const to = item.view ? `${item.path}?view=${item.view}` : item.path;
  const active = isItemActive(item);

  return (
    <NavLink
      to={to}
      className={() => `sidebar-item ${active ? 'active' : ''}`}
      onClick={onClose}
    >
      <span className="sidebar-icon"><Icon name={item.icon} /></span>
      <span className="sidebar-label">{item.label}</span>
    </NavLink>
  );
};

const Sidebar = ({ isOpen, onClose }) => {
  const reduxUserType = useSelector(state => state.auth.user?.userType);
  const userType = reduxUserType || getCurrentUserType();
  const navItems = getNavItems(userType);

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`app-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Manzili Smart" />
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <SidebarItem key={item.id} item={item} onClose={onClose} />
          ))}
        </nav>
        <div className="sidebar-footer">
          <span className="sidebar-version">Admin Panel</span>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
